<ion-app>
  
  <ion-menu contentId="my-content" side="end"><app-menu></app-menu></ion-menu>
  <ion-router-outlet id="my-content"></ion-router-outlet>

</ion-app>